import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-primary-dark py-12 px-4 border-y border-primary/40" data-id="element-108">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109">
        <ShieldCheck className="w-16 h-16 md:w-20 md:h-20 text-gold mx-auto mb-4" data-id="element-110" />
        <h2 className="text-3xl md:text-4xl font-bold text-cream mb-5" data-id="element-111">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <div className="space-y-3 text-base md:text-lg text-cream/90 mb-6" data-id="element-112">
          <p data-id="element-113">Abrís los tomos. Los usás con tu hijo.</p>
          <p data-id="element-114">
            Si en 7 días no notás una mejora real en la concentración de tu hijo
            y en la paz de tu casa:
          </p>
          <p className="font-bold text-xl text-cream" data-id="element-115">
            devolución del 100% sin formularios, sin drama.
          </p>
        </div>
        <div className="inline-block bg-dark-900/50 px-6 py-3 rounded-full border border-primary/40" data-id="element-116">
          <p className="text-primary font-medium" data-id="element-117">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}